/// <reference path="../_references.ts"/>

module App.Timeclock {
	import TitleBarService = App.Helpers.TitleBarService;
	import UserSession = App.User.UserSession;

	export class TimeclockButtonController {
		static $inject = ['$q', 'UserSession', 'TimeclockService'];

		public isClocking: boolean = true;
		public loading: boolean = true;

		constructor(
			protected $q: ng.IQService,
			protected UserSession: UserSession,
			protected TimeclockService: TimeclockService
		) {
			UserSession.fetchSessionData().then(() => {
				this.isClocking = false;
				this.loading = false;
			});
		}

		isClocked(): boolean {
			return this.loading || this.UserSession.isClocked();
		}

		toggleClocked(): void {
			if (this.isClocking) return;
			this.isClocking = true;

			this.UserSession.getUser().then((user) => {
				let clock: (techId: number) => ng.IPromise<Timeclock> = this.isClocked()
					? this.TimeclockService.clockOut
					: this.TimeclockService.clockIn;

				clock.bind(this.TimeclockService)(user.technician.id).then((timeclock: Timeclock) => {
					user.technician.latest_time = timeclock;
					this.UserSession.setUser(user);
					this.isClocking = false;
				});
			});
		}
	}
}
